import { Component, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { BreadcrumbService } from "./domain/service/breadcrumb/breadcrumb.service";
import { Capacitor } from "@capacitor/core";
import { SplashScreen } from "@capacitor/splash-screen";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.css",
})
export class AppComponent implements OnInit {
  title = "turistWeb";
  breadcrumbs: { label: string; url: string }[] = [];
  constructor(private router: Router, private breadcrumbService: BreadcrumbService) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const route = this.router.routerState.snapshot.root;
        this.breadcrumbs = this.breadcrumbService.generateBreadcrumbs(route);
      }
    });
  }

  ngOnInit(): void {
    // The splash is held until the app is ready (launchAutoHide: false).
    // Hide it now that Angular has bootstrapped. Native only.
    if (Capacitor.isNativePlatform()) {
      SplashScreen.hide();
    }
  }
}
